﻿namespace WebPortal {
    export class Validation {
        private ChangePasswordModal: WebPortal.Dialog.Modal.ChangePassword;

        constructor(_ChangePasswordModal: WebPortal.Dialog.Modal.ChangePassword) {
            this.ChangePasswordModal = _ChangePasswordModal;
            this.init();
        }

        private init(): void {
            this.setDefaultforValidator();
            this.setValitator();
        }

        private setDefaultforValidator(): void {
            console.log("setDefaultforValidator");
            $.validator.setDefaults({
                highlight: (element: HTMLElement): void => {
                    $(element).closest(".form-group").addClass("has-error");
                },
                unhighlight: (element: HTMLElement): void => {
                    $(element).closest(".form-group").removeClass("has-error");
                },
                errorElement: "span",
                errorClass: "help-block help-block-custom",
                errorPlacement: (error: JQuery, element: JQuery): void => {
                    if (element.parent(".input-group").length) {
                        error.insertAfter(element.parent());
                    } else {
                        error.insertAfter(element);
                    }
                }
            });

            $.validator.addMethod("notEqualPassword", function (value: any, element: HTMLElement, params: any): boolean {
                return this.optional(element) || value !== $(params).val();
            }, "Please choose a different Password");

            $.validator.addMethod("regex", function (value, element, regexp) {
                return this.optional(element) || regexp.test(value);
            },
                "The password does not have the according complexity"
            );
        }

        private setValitator(): void {
            console.log("setValitator");
            $("#main_form").validateWebForm({
                // debug: true,
                submitHandler: (form: any, event: any): void => {
                    //  if (event.target.id === "bt_change_password_save") {
                    this.ChangePasswordModal.change;
                    // }

                    //  return false;
                }
            });
        }
    }
}